import { render, staticRenderFns } from "./layoutSidebar.vue?vue&type=template&id=3a9c9fbe&scoped=true"
import script from "./layoutSidebar.vue?vue&type=script&lang=ts"
export * from "./layoutSidebar.vue?vue&type=script&lang=ts"
import style0 from "./layoutSidebar.vue?vue&type=style&index=0&id=3a9c9fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9c9fbe",
  null
  
)

export default component.exports